/**
 * https://www.pdftron.com/api/web/Core.AnnotationManager.html#getCurrentUser__anchor
 */
export default () => window.documentViewer.getAnnotationManager().getCurrentUser();
